import 'firebase/database';
import 'firebase/auth';
import firebase from 'firebase/app';


// GET CONTRACTS
export const GET_ALL_CATEGORIES_PENDING = 'GET_ALL_CATEGORIES_PENDING';
export const GET_ALL_CATEGORIES_FULFILLED = 'GET_ALL_CATEGORIES_FULFILLED';
export const GET_ALL_CATEGORIES_REJECTED = 'GET_ALL_CATEGORIES_REJECTED';

export const GET_ALL_TYPES_PENDING = 'GET_ALL_TYPES_PENDING';
export const GET_ALL_TYPES_FULFILLED = 'GET_ALL_TYPES_FULFILLED';
export const GET_ALL_TYPES_REJECTED = 'GET_ALL_TYPES_REJECTED';

export const GET_TYPE_PENDING = 'GET_TYPE_PENDING';
export const GET_TYPE_FULFILLED = 'GET_TYPE_FULFILLED';
export const GET_TYPE_REJECTED = 'GET_TYPE_REJECTED';

export const GET_CATEGORY_PENDING = 'GET_CATEGORY_PENDING';
export const GET_CATEGORY_FULFILLED = 'GET_CATEGORY_FULFILLED';
export const GET_CATEGORY_REJECTED = 'GET_CATEGORY_REJECTED';

export const GET_TYPES_PENDING = 'GET_TYPES_PENDING';
export const GET_TYPES_FULFILLED = 'GET_TYPES_FULFILLED';
export const GET_TYPES_REJECTED = 'GET_TYPES+REJECTED';

const getAllCategories = () => (dispatch) => {

    dispatch({
        type: GET_ALL_CATEGORIES_PENDING
    }); 

    firebase.database().ref('/products/').child(localStorage.getItem('companyID')).child('config').child('categories').once('value').then(snapshot => {
        const categories = snapshot.val();

        let categoriesWithIds = Object.keys(categories).map((categoryId) => { 
            let categoryItem = categories[categoryId];
            categoryItem['id'] = categoryId;
            return categoryItem;
        });

        dispatch({
            type: GET_ALL_CATEGORIES_FULFILLED,
            payload: categoriesWithIds
        });
    });
};

const getProductCategory = (categoryID) => (dispatch) => {

    dispatch({
        type: GET_CATEGORY_PENDING
    }); 

    firebase.database().ref('/products/').child(localStorage.getItem('companyID')).child('config').child('categories').child(categoryID).once('value').then(snapshot => {
        const category = snapshot.val();

        category.id = categoryID;

        dispatch({
            type: GET_CATEGORY_FULFILLED,
            payload: category
        });
    });
};

const getAllProductTypes = () => (dispatch) => {

    dispatch({
        type: GET_ALL_TYPES_PENDING
    }); 

    firebase.database().ref('/products/').child(localStorage.getItem('companyID')).child('config').child('types').once('value').then(snapshot => {
        const types = snapshot.val();

        let typesWithIds = Object.keys(types).map((typeID) => { 
            let typeItem = types[typeID];
            typeItem['id'] = typeID;
            return typeItem;
        });

        dispatch({
            type: GET_ALL_TYPES_FULFILLED,
            payload: typesWithIds
        });
    });
};

const getProductTypes = (typeIDs) => (dispatch) => {
    dispatch({
        type: GET_TYPES_PENDING
    }); 
    
    let types = [];
    let retrievedCount = 0;
    if (typeIDs == undefined) {
        dispatch({
            type: GET_TYPES_FULFILLED,
            payload: types
        });
    } else {
        typeIDs.forEach(function(typeID) {
            firebase.database().ref('/products/' + localStorage.getItem('companyID') + '/config/types/'+ typeID).once('value').then(snapshot => {
                const type = snapshot.val();
                if(type != undefined) {
                    type.id = typeID;
                    types.push(type);
                }
                
                retrievedCount++;
                
                if(retrievedCount == Object.keys(typeIDs).length) {
                    dispatch({
                        type: GET_TYPES_FULFILLED,
                        payload: types
                    });
                }
            });
        });
    }
};

const getProductType = (typeID) => (dispatch) => {

    dispatch({
        type: GET_TYPE_PENDING
    }); 

    firebase.database().ref('/products/').child(localStorage.getItem('companyID')).child('config').child('types').child(typeID).once('value').then(snapshot => {
        const type = snapshot.val();

        type.id = typeID;

        dispatch({
            type: GET_TYPE_FULFILLED,
            payload: type
        });
    });
};

export { getAllCategories, getAllProductTypes, getProductType, getProductCategory, getProductTypes };


// WEBPACK FOOTER //
// ./src/components/state/actions/CategoryActions.js